import "react";
import { clsx as p } from "./clsx.mjs";
import { getPickersFadeTransitionGroupUtilityClass as c } from "./pickersFadeTransitionGroupClasses.mjs";
import { jsx as s } from "react/jsx-runtime";
import u from "./styled.mjs";
import l from "./TransitionGroup.mjs";
import d from "./useThemeProps.mjs";
import f from "./useTheme.mjs";
import T from "./Fade.mjs";
import h from "./composeClasses.mjs";
const k = (r) => {
  const {
    classes: o
  } = r;
  return h({
    root: ["root"]
  }, c, o);
}, F = u(l, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (r, o) => o.root
})({
  display: "block",
  position: "relative"
});
function N(r) {
  const o = d({
    props: r,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: t,
    className: i,
    reduceAnimations: n,
    transKey: a
  } = o, m = k(o), e = f();
  return n ? t : /* @__PURE__ */ s(F, {
    className: p(m.root, i),
    children: /* @__PURE__ */ s(T, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: e.transitions.duration.enteringScreen,
        enter: e.transitions.duration.enteringScreen,
        exit: 0
      },
      children: t
    }, a)
  });
}
export {
  N as PickersFadeTransitionGroup
};
//# sourceMappingURL=PickersFadeTransitionGroup.mjs.map
